var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimulatoricon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 52.62,
    x2: 297.38,
    y1: 175,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3250fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9e70ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2aceeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbf38"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M279.88 49.34v251.32H70.12V49.34h209.76m17.5-17.5H52.62v286.32h244.76V31.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M223.22 129.1h16.63a7.64 7.64 0 0 0 7.64-7.64v-32a7.63 7.63 0 0 0-7.64-7.63h-16.63a7.63 7.63 0 0 0-7.63 7.63v32a7.64 7.64 0 0 0 7.63 7.64zm-.16-39.68a.16.16 0 0 1 .16-.16h16.63a.17.17 0 0 1 .17.16v32a.17.17 0 0 1-.17.16h-16.63a.16.16 0 0 1-.16-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbec0",
    d: "M223.22 89.26h16.63a.17.17 0 0 1 .17.17v32a.17.17 0 0 1-.17.17h-16.63a.16.16 0 0 1-.16-.16v-32a.16.16 0 0 1 .16-.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbec0",
    d: "M101.75 138.27h146.5A11.31 11.31 0 0 0 259.56 127V84a11.31 11.31 0 0 0-11.31-11.32h-146.5a11.31 11.31 0 0 0-11.31 11.25v43a11.31 11.31 0 0 0 11.31 11.34zm113.84-48.85a7.63 7.63 0 0 1 7.63-7.63h16.63a7.63 7.63 0 0 1 7.64 7.63v32a7.64 7.64 0 0 1-7.64 7.64h-16.63a7.64 7.64 0 0 1-7.63-7.64z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulatoricon);
export default __webpack_public_path__ + "static/media/simulatoricon.3303a3054606618f40ddfbb4f0661023.svg";
export { ForwardRef as ReactComponent };